import { Pipe, PipeTransform } from '@angular/core';
import { gfDateFunction } from './date.functions';

@Pipe({
    name: 'gfDate'
})
export class DateGfDatePipe implements PipeTransform {
    transform(inputValue?: any, format?: string, locale?: string): string {
        return gfDateFunction(inputValue, format, locale);
    }
};